<template>
  <div
    class="bg-white shadow-xl rounded-mdk p-4 mb- mt-4 border border-gray-100"
  >
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 py-2">
      <div class="bg-gray-50 p-4 rounded-lg border space-y-2">
        <h3 class="font-semibold text-gray-700">Début de l'appel (De)</h3>

        <!-- TYPE -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-"
            >Type de l'appelant</label
          >
          <select
            v-model="filters.origin_dn_type"
            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-teal-500 focus:border-teal-500 transition text-sm capitalize"
          >
            <option value="">Tous</option>
            <option value="4">{{ $t("queue") }}</option>
            <option value="0">{{ $t("user") }}</option>
          </select>
        </div>

        <!-- NUMÉRO -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-">
            Numéro de l'appelant
          </label>

          <InputSearchSelector
            v-if="filters.origin_dn_type"
            :key="origin_key"
            v-model:searchElement="searchElementOrigin"
            :searchData="
              filters?.origin_dn_type === '4'
                ? queueListSlicedOrigin
                : extensionsListSlicedOrigin
            "
            :infiniteHandler="
              filters?.origin_dn_type === '4'
                ? infiniteHandlerOriginQueue
                : infiniteHandlerOriginExtension
            "
            :selected="selectedOriginDns"
            :urlType="filters?.origin_dn_type === '4' ? 'queue' : 'extension'"
            :addElement="addOriginDn"
            :slicedListIncludes="
              filters?.origin_dn_type === '4'
                ? slicedListQueueOriginIncludes
                : slicedListExtensionOriginIncludes
            "
            :elementListConcatReduce="
              filters?.origin_dn_type === '4'
                ? queuesReduced
                : extensionsReduced
            "
          />

          <div
            v-else
            class="w-full px-3 py-2 text-sm border rounded-md bg-gray-100 text-gray-400 cursor-not-allowed"
          >
            Choisissez d'abord un type
          </div>
        </div>
        <div class="pt-2">
          <div
            class="flex items-start text-xs text-gray-500 p-2 bg-white rounded-md border border-gray-200"
          >
            <!-- <span class="mr-1 mt-0.5 text-teal-600">❓</span> -->
            <span class="leading-snug"
              >Filtre les appels démarrés par un utilisateur, une file d'attente
              ou tout autre élément spécifique.</span
            >
          </div>
        </div>
      </div>

      <div class="bg-gray-50 p-4 rounded-lg border space-y-2">
        <h3 class="font-semibold text-gray-700">Fin de l'appel (Vers)</h3>

        <!-- TYPE -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-"
            >Type du destinataire</label
          >
          <select
            v-model="filters.destination_dn_type"
            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-teal-500 focus:border-teal-500 transition text-sm capitalize"
          >
            <option value="">Tous</option>
            <option value="4">{{ $t("queue") }}</option>
            <option value="0">{{ $t("user") }}</option>
          </select>
        </div>

        <!-- NUMÉRO -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-">
            Numéro du destinataire
          </label>

          <InputSearchSelector
            v-if="filters.destination_dn_type"
            :key="destination_key"
            v-model:searchElement="searchElement"
            :searchData="
              filters?.destination_dn_type === '4'
                ? queueListSlicedDestination
                : extensionsListSlicedDestination
            "
            :infiniteHandler="
              filters?.destination_dn_type === '4'
                ? infiniteHandlerDestinationQueue
                : infiniteHandlerDestinationExtension
            "
            :selected="selectedDestinationDns"
            :urlType="
              filters?.destination_dn_type === '4' ? 'queue' : 'extension'
            "
            :addElement="addDestinationDn"
            :slicedListIncludes="
              filters?.destination_dn_type === '4'
                ? slicedListQueueDestinationIncludes
                : slicedListExtensionDestinationIncludes
            "
            :elementListConcatReduce="
              filters?.destination_dn_type === '4'
                ? queuesReduced
                : extensionsReduced
            "
          />

          <div
            v-else
            class="w-full px-3 py-2 text-sm border rounded-md bg-gray-100 text-gray-400 cursor-not-allowed"
          >
            Choisissez d'abord un type
          </div>
        </div>
        <div class="pt-2">
          <div
            class="flex items-start text-xs text-gray-500 p-2 bg-white rounded-md border border-gray-200"
          >
            <!-- <span class="mr-1 mt-0.5 text-teal-600">❓</span> -->
            <span class="leading-snug"
              >Filtre les appels terminés par un utilisateur, une file d'attente
              ou tout autre élément spécifique.</span
            >
          </div>
        </div>
      </div>
      <div class="bg-gray-50 p-4 rounded-lg border space-y-2">
        <h3 class="font-semibold text-gray-700">Identification des Numéros</h3>

        <div>
          <label class="block text-sm font-semibold text-gray-700"
            >Numéro Accédé (SDA)</label
          >
          <InputSearchSelector
            :key="did_key"
            v-model:searchElement="searchElementDID"
            :searchData="DIDsListSliced"
            :infiniteHandler="infiniteHandlerDID"
            :selected="selectedDidNumbers"
            urlType="did"
            :addElement="addDidNumber"
            :slicedListIncludes="slicedListDIDIncludes"
            :elementListConcatReduce="didsReduced"
          />
        </div>

        <div>
          <label class="block text-sm font-semibold text-gray-700"
            >Numéro Externe Appelant</label
          >
          <InputSearchSelector
            :key="did_key"
            v-model:searchElement="searchElementCallerNumber"
            :searchData="callerNumberList"
            :infiniteHandler="infiniteHandlerCallerNumber"
            :selected="selectedCallerNumbers"
            urlType="caller"
            :addElement="addCallerNumber"
            :slicedListIncludes="slicedListCallerIncludes"
            :elementListConcatReduce="callersReduced"
          />
        </div>
        <div class="pt-2">
          <div
            class="flex items-start text-xs text-gray-500 p-2 bg-white rounded-md border border-gray-200"
          >
            <span class="leading-snug"
              >Filtrez par le numéro public composé par l'appelant externe (SDA)
              et/ou par le numéro de téléphone de l'appelant (Externe).</span
            >
          </div>
        </div>
      </div>
      <div class="bg-gray-50 p-4 rounded-lg border space-y-2">
        <h3 class="font-semibold text-gray-700">Flux & Résultat de l'Appel</h3>

        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-0"
            >Type de Flux d'Appel</label
          >
          <select
            v-model="filters.call_way"
            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-teal-500 focus:border-teal-500 transition text-sm"
          >
            <option value="">Tous</option>
            <option value="inbound">Entrant</option>
            <option value="outbound">Sortant</option>
            <option value="internal">Interne</option>
          </select>
        </div>

        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-0"
            >Résultat de l'Appel</label
          >
          <select
            v-model="filters.call_status"
            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-teal-500 focus:border-teal-500 transition text-sm"
          >
            <option value="all">Tous</option>
            <option value="answered">Répondu</option>
            <option value="unanswered">Non Répondu</option>
          </select>
        </div>
        <div class="pt-2">
          <div
            class="flex items-start text-xs text-gray-500 p-2 bg-white rounded-md border border-gray-200"
          >
            <span class="leading-snug"
              >Sélectionnez la direction du flux (Entrant, Sortant, Interne) et
              si l'appel a été Répondu ou non.</span
            >
          </div>
        </div>
      </div>
      <div class="">
        <div v-if="showLessOrigin" class="lg:grid grid-cols-2 gap-2">
          <span
            v-for="element in selectedOriginDns.slice(0, 4)"
            :key="element"
            class="flex items-center justify-between px-2 rounded-full bg-gray-200 py-1 text-xs font-medium text-gray-700"
          >
            <span
              v-if="pbxMap"
              class="truncate"
              :title="
                element +
                '-' +
                (filters?.origin_dn_type === '4'
                  ? pbxMap?.call_queues[element]?.name
                  : pbxMap?.extensions[element])
              "
            >
              {{ element }}-{{
                filters?.origin_dn_type === "4"
                  ? pbxMap?.call_queues[element]?.name
                  : pbxMap?.extensions[element]
              }}
            </span>
            <button
              type="button"
              @click="elementRemovedOrigin(element)"
              class="rounded-full text-gray-400 hover:bg-gray-200 hover:text-gray-500 focus:bg-gray-500 focus:text-white focus:outline-none"
            >
              <svg
                class="h-2 w-2"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 8 8"
              >
                <path
                  stroke-linecap="round"
                  stroke-width="1.5"
                  d="M1 1l6 6m0-6L1 7"
                />
              </svg>
            </button>
          </span>
        </div>
        <div v-else class="lg:grid grid-cols-2 gap-2">
          <span
            v-for="element in selectedOriginDns"
            :key="element"
            class="flex items-center justify-between px-2 rounded-full bg-gray-200 py-1 text-xs font-medium text-gray-700"
          >
            <span
              class="truncate"
              :title="
                element +
                '-' +
                (filters?.origin_dn_type === '4'
                  ? pbxMap?.call_queues[element]?.name
                  : pbxMap?.extensions[element])
              "
            >
              {{ element }}-{{
                filters?.origin_dn_type === "4"
                  ? pbxMap?.call_queues[element]?.name
                  : pbxMap?.extensions[element]
              }}
            </span>
            <button
              type="button"
              @click="elementRemovedOrigin(element)"
              class="rounded-full text-gray-400 hover:bg-gray-200 hover:text-gray-500 focus:bg-gray-500 focus:text-white focus:outline-none"
            >
              <svg
                class="h-2 w-2"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 8 8"
              >
                <path
                  stroke-linecap="round"
                  stroke-width="1.5"
                  d="M1 1l6 6m0-6L1 7"
                />
              </svg>
            </button>
          </span>
        </div>
        <div v-show="selectedOriginDns.length > 4" class="my-1">
          <span
            v-show="showLessOrigin"
            class="text-xs italic text-gray-500 flex justify-center"
          >
            {{
              $t("andNumberMoreElements", {
                numb: selectedOriginDns.length - 4,
              })
            }}
          </span>
          <div class="flex justify-center mt-0.5">
            <button
              @click="showLessOrigin = !showLessOrigin"
              class="rounded-lg text-gray-700 bg-white hover:bg-grey-100 border-gray-300 hover:bg-gray-50 hover:shadow-md shadow-sm px-1 py-0.5 border text-xs"
            >
              {{ showLessOrigin ? $t("showMore") : $t("showLess") }}
            </button>
          </div>
        </div>
      </div>
      <div class="">
        <div v-if="showLess" class="lg:grid grid-cols-2 gap-2">
          <span
            v-for="element in selectedDestinationDns.slice(0, 4)"
            :key="element"
            class="flex items-center justify-between px-2 rounded-full bg-gray-200 py-1 text-xs font-medium text-gray-700"
          >
            <span
              class="truncate"
              :title="
                element +
                '-' +
                (filters?.destination_dn_type === '4'
                  ? pbxMap?.call_queues[element]?.name
                  : pbxMap?.extensions[element])
              "
            >
              {{ element }}-{{
                filters?.destination_dn_type === "4"
                  ? pbxMap?.call_queues[element]?.name
                  : pbxMap?.extensions[element]
              }}
            </span>
            <button
              type="button"
              @click="elementRemovedDestination(element)"
              class="rounded-full text-gray-400 hover:bg-gray-200 hover:text-gray-500 focus:bg-gray-500 focus:text-white focus:outline-none"
            >
              <svg
                class="h-2 w-2"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 8 8"
              >
                <path
                  stroke-linecap="round"
                  stroke-width="1.5"
                  d="M1 1l6 6m0-6L1 7"
                />
              </svg>
            </button>
          </span>
        </div>
        <div v-else class="lg:grid grid-cols-2 gap-2">
          <span
            v-for="element in selectedDestinationDns"
            :key="element"
            class="flex items-center justify-between px-2 rounded-full bg-gray-200 py-1 text-xs font-medium text-gray-700"
          >
            <span
              class="truncate"
              :title="
                element +
                '-' +
                (filters?.destination_dn_type === '4'
                  ? pbxMap?.call_queues[element]?.name
                  : pbxMap?.extensions[element])
              "
            >
              {{ element }}-{{
                filters?.destination_dn_type === "4"
                  ? pbxMap?.call_queues[element]?.name
                  : pbxMap?.extensions[element]
              }}
            </span>
            <button
              type="button"
              @click="elementRemovedDestination(element)"
              class="rounded-full text-gray-400 hover:bg-gray-200 hover:text-gray-500 focus:bg-gray-500 focus:text-white focus:outline-none"
            >
              <svg
                class="h-2 w-2"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 8 8"
              >
                <path
                  stroke-linecap="round"
                  stroke-width="1.5"
                  d="M1 1l6 6m0-6L1 7"
                />
              </svg>
            </button>
          </span>
        </div>
        <div v-show="selectedDestinationDns.length > 4" class="my-1">
          <span
            v-show="showLess"
            class="text-xs italic text-gray-500 flex justify-center"
          >
            {{
              $t("andNumberMoreElements", {
                numb: selectedDestinationDns.length - 4,
              })
            }}
          </span>
          <div class="flex justify-center mt-0.5">
            <button
              @click="showLess = !showLess"
              class="rounded-lg text-gray-700 bg-white hover:bg-grey-100 border-gray-300 hover:bg-gray-50 hover:shadow-md shadow-sm px-1 py-0.5 border text-xs"
            >
              {{ showLess ? $t("showMore") : $t("showLess") }}
            </button>
          </div>
        </div>
      </div>
      <div class="">
        <div v-if="showLessDid" class="lg:grid grid-cols-2 gap-2">
          <span
            v-for="element in selectedDidNumbers.slice(0, 4)"
            :key="element"
            class="flex items-center justify-between px-2 rounded-full bg-gray-200 py-1 text-xs font-medium text-gray-700"
          >
            <span class="truncate" :title="element">
              {{ element }}
            </span>
            <button
              type="button"
              @click="elementRemovedDid(element)"
              class="rounded-full text-gray-400 hover:bg-gray-200 hover:text-gray-500 focus:bg-gray-500 focus:text-white focus:outline-none"
            >
              <svg
                class="h-2 w-2"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 8 8"
              >
                <path
                  stroke-linecap="round"
                  stroke-width="1.5"
                  d="M1 1l6 6m0-6L1 7"
                />
              </svg>
            </button>
          </span>
        </div>
        <div v-else class="lg:grid grid-cols-2 gap-2">
          <span
            v-for="element in selectedDidNumbers"
            :key="element"
            class="flex items-center justify-between px-2 rounded-full bg-gray-200 py-1 text-xs font-medium text-gray-700"
          >
            <span class="truncate" :title="element">
              {{ element }}
            </span>
            <button
              type="button"
              @click="elementRemovedDid(element)"
              class="rounded-full text-gray-400 hover:bg-gray-200 hover:text-gray-500 focus:bg-gray-500 focus:text-white focus:outline-none"
            >
              <svg
                class="h-2 w-2"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 8 8"
              >
                <path
                  stroke-linecap="round"
                  stroke-width="1.5"
                  d="M1 1l6 6m0-6L1 7"
                />
              </svg>
            </button>
          </span>
        </div>
        <div v-show="selectedDidNumbers.length > 4" class="my-1">
          <span
            v-show="showLessDid"
            class="text-xs italic text-gray-500 flex justify-center"
          >
            {{
              $t("andNumberMoreElements", {
                numb: selectedDidNumbers.length - 4,
              })
            }}
          </span>
          <div class="flex justify-center mt-0.5">
            <button
              @click="showLessDid = !showLessDid"
              class="rounded-lg text-gray-700 bg-white hover:bg-grey-100 border-gray-300 hover:bg-gray-50 hover:shadow-md shadow-sm px-1 py-0.5 border text-xs"
            >
              {{ showLessDid ? $t("showMore") : $t("showLess") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex justify-start text-xs text-gray-500 px-2 pb-2 items-center"
    >
      <span class="mr-2 mt-0.5 text-sm">💡</span>
      <span class="leading-snug font-medium">
        N'oubliez pas de cliquer sur le bouton "Appliquer les filtres"
        ci-dessous pour mettre à jour le tableau.
      </span>
    </div>

    <div
      class="pt-4 mt- border-t border-gray-100 flex items-center justify-end gap-4 text-sm"
    >
      <button
        class="bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-xl transition font-medium"
        @click="$emit('resetFilters')"
      >
        Réinitialiser
      </button>
      <button
        class="bg-teal-600 hover:bg-teal-700 text-white px-4 py-2 rounded-xl transition font-medium shadow-md shadow-teal-500/30"
        @click="$emit('applyFilters')"
      >
        Appliquer les Filtres
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InputSearchSelector from "../InputSearchSelector.vue";
import { mapGetters } from "vuex";

export default {
  emits: [
    "applyFilters",
    "resetFilters",
    "update:callStatus",
    "clearOriginDns",
    "clearDestinationDns",
  ],
  components: {
    InputSearchSelector,
  },
  props: [
    "callQueuesGroups",
    "closeFormButton",
    "element",
    "selectedPbxElements",
    "elementsData",
    "name",
    "selectedElementsLength",
    "addElement",
    "selectedPbxElementsFromEdit",
    "isEdit",
    "groupId",
    "filters",
    "extensionsReduced",
    "queuesReduced",
    "didsReduced",
    "callersReduced",
    "selectedOriginDns",
    "selectedDestinationDns",
    "selectedDidNumbers",
    "selectedCallerNumbers",
    "addOriginDn",
    "addDestinationDn",
    "addDidNumber",
    "addCallerNumber",
    "callStatus",
    "elementRemovedDestination",
    "elementRemovedOrigin",
    "elementRemovedDid",
  ],
  data() {
    return {
      searchElement: "",
      searchElementOrigin: "",
      searchElementDID: "",
      searchElementCallerNumber: "",
      showMessage: false,
      queueList: [],
      callerNumberList: [],
      queueListSlicedDestination: [],
      queueListSlicedOrigin: [],
      extensionsList: [],
      extensionsListSlicedDestination: [],
      extensionsListSlicedOrigin: [],
      DIDsList: [],
      DIDsListSliced: [],
      elements: [],
      elementToRemove: "",
      sliceElementsDestination: 500,
      sliceElementsOrigin: 500,
      sliceElementsDID: 500,
      destination_key: 0,
      sliceElementsCallerNumber: 500,
      origin_key: 0,
      did_key: 0,
      callStatus: "all",
      showLess: true,
      showLessOrigin: true,
      showLessDid: true,
    };
  },
  methods: {
    infiniteHandlerDID($state) {
      setTimeout(
        function () {
          if (this.DIDsListSliced.length == this.didsReduced.length) {
            $state.complete();
          } else {
            this.DIDsListSliced = this.DIDsListSliced.concat(
              this.didsReduced.slice(
                this.sliceElementsDID - 500,
                this.sliceElementsDID,
              ),
            );
            this.sliceElementsDID = this.sliceElementsDID + 500;
          }
          $state.loaded();
        }.bind(this),
        1000,
      );
    },
    infiniteHandlerCallerNumber($state) {
      setTimeout(
        function () {
          if (this.callerNumberList.length == this.callersReduced.length) {
            $state.complete();
          } else {
            this.callerNumberList = this.callerNumberList.concat(
              this.callersReduced.slice(
                this.sliceElementsCallerNumber - 500,
                this.sliceElementsCallerNumber,
              ),
            );
            this.sliceElementsCallerNumber =
              this.sliceElementsCallerNumber + 500;
          }
          $state.loaded();
        }.bind(this),
        1000,
      );
    },
    slicedListDIDIncludes() {
      let flag = false;
      let list = this.DIDsListSliced;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        if (element.label.includes(this.searchElementDID)) {
          flag = true;
        }
      }
      return flag;
    },
    slicedListCallerIncludes() {
      let flag = false;
      let list = this.callerNumberList;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        if (element.label.includes(this.searchElementCallerNumber)) {
          flag = true;
        }
      }
      return flag;
    },
    infiniteHandlerDestinationExtension($state) {
      this.queueListSlicedDestination = [];
      setTimeout(
        function () {
          if (
            this.extensionsListSlicedDestination.length ==
            this.extensionsReduced.length
          ) {
            $state.complete();
          } else {
            this.extensionsListSlicedDestination =
              this.extensionsListSlicedDestination.concat(
                this.extensionsReduced.slice(
                  this.sliceElementsDestination - 500,
                  this.sliceElementsDestination,
                ),
              );
            this.sliceElementsDestination = this.sliceElementsDestination + 500;
          }
          $state.loaded();
        }.bind(this),
        1000,
      );
    },
    infiniteHandlerDestinationQueue($state) {
      this.extensionsListSlicedDestination = [];
      setTimeout(
        function () {
          if (
            this.queueListSlicedDestination.length == this.queuesReduced.length
          ) {
            $state.complete();
          } else {
            this.queueListSlicedDestination =
              this.queueListSlicedDestination.concat(
                this.queuesReduced.slice(
                  this.sliceElementsDestination - 500,
                  this.sliceElementsDestination,
                ),
              );
            this.sliceElementsDestination = this.sliceElementsDestination + 500;
          }
          $state.loaded();
        }.bind(this),
        1000,
      );
    },
    slicedListExtensionDestinationIncludes() {
      let flag = false;
      let list = this.extensionsListSlicedDestination;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        if (element.label.includes(this.searchElement)) {
          flag = true;
        }
      }
      return flag;
    },
    slicedListQueueDestinationIncludes() {
      let flag = false;
      let list = this.queueListSlicedDestination;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        if (element.label.includes(this.searchElement)) {
          flag = true;
        }
      }
      return flag;
    },
    infiniteHandlerOriginExtension($state) {
      this.queueListSlicedOrigin = []; // Clear the other list
      setTimeout(
        function () {
          if (
            this.extensionsListSlicedOrigin.length ==
            this.extensionsReduced.length
          ) {
            $state.complete();
          } else {
            this.extensionsListSlicedOrigin =
              this.extensionsListSlicedOrigin.concat(
                this.extensionsReduced.slice(
                  this.sliceElementsOrigin - 500,
                  this.sliceElementsOrigin,
                ),
              );
            this.sliceElementsOrigin = this.sliceElementsOrigin + 500;
          }
          $state.loaded();
        }.bind(this),
        1000,
      );
    },
    infiniteHandlerOriginQueue($state) {
      this.extensionsListSlicedOrigin = []; // Clear the other list
      setTimeout(
        function () {
          if (this.queueListSlicedOrigin.length == this.queuesReduced.length) {
            $state.complete();
          } else {
            this.queueListSlicedOrigin = this.queueListSlicedOrigin.concat(
              this.queuesReduced.slice(
                this.sliceElementsOrigin - 500,
                this.sliceElementsOrigin,
              ),
            );
            this.sliceElementsOrigin = this.sliceElementsOrigin + 500;
          }
          $state.loaded();
        }.bind(this),
        1000,
      );
    },
    slicedListExtensionOriginIncludes() {
      let flag = false;
      let list = this.extensionsListSlicedOrigin;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        // Use the Origin-specific search term
        if (element.label.includes(this.searchElementOrigin)) {
          flag = true;
        }
      }
      return flag;
    },
    slicedListQueueOriginIncludes() {
      let flag = false;
      let list = this.queueListSlicedOrigin;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        // Use the Origin-specific search term
        if (element.label.includes(this.searchElementOrigin)) {
          flag = true;
        }
      }
      return flag;
    },
    getPbxMap() {
      const options = {
        method: "GET",
        url: `${localStorage.getItem("apiUrl")}/api/v1.2/${this.hostName}/map`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("apiToken")}`,
        },
      };
      axios
        .request(options)
        .then((res) => {
          let obj = {};
          let objDID = {};
          let objQueue = {};
          let extensionsArray = [];
          let keysExtensions = Object.keys(res.data.extensions);
          let keysDIDs = res.data.dids;
          let keysQueue = Object.keys(res.data.call_queues);
          keysExtensions.forEach((element, index) => {
            obj = {};
            obj["value"] = keysExtensions[index];
            obj["label"] =
              keysExtensions[index] + " - " + res.data.extensions[element];
            obj["type"] = "extension";
            this.extensionsList.push(obj);
          });
          keysDIDs.forEach((element, index) => {
            objDID = {};
            objDID["value"] = element;
            objDID["label"] = element;
            objDID["type"] = "did";
            this.DIDsList.push(objDID);
          });
          keysQueue.forEach((element, index) => {
            objQueue = {};
            objQueue["value"] = keysQueue[index];
            objQueue["label"] =
              keysQueue[index] + " - " + res.data.call_queues[element].name;
            objQueue["members"] = res.data.call_queues[element].members;
            objQueue["type"] = "queue";
            this.queueList.push(objQueue);
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async getGroupData() {
      try {
        const res = await axios.get(
          `${localStorage.getItem("apiUrl")}/api/v1.2/${
            this.hostName
          }/resource-groups/${this.groupId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("apiToken")}`,
            },
          },
        );
        if (res) {
          this.form.name = res.data.name;
        }
      } catch (error) {
        this.$emit("activeBanner");
        this.$emit("success", false);
        this.$emit("successMsg", "Something went wrong");
        this.errorHandling(error);
      }
    },
  },
  computed: {
    ...mapGetters(["hostName", "pbxMap"]),
  },
  mounted() {
    this.getPbxMap();
  },
  watch: {
    searchElementCallerNumber: {
      async handler(val) {
        if (val.length >= 2) {
          try {
            const res = await axios.get(
              `${this.$cookie.getCookie("API")}/api/v1.2/${
                this.hostName
              }/caller-numbers`,
              {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("token"),
                },
                params: { search: val },
              },
            );

            this.callerNumberList = res.data.data.map((item) => ({
              value: item.caller_number,
              label: `${item.caller_number}`,
              type: "caller",
            }));
          } catch (e) {
            console.error(e);
          }
        }

        if (val.length < 2) {
          this.callerNumberList = [];
          this.callerNumberList.push(...this.callersReduced.slice(0, 500));
        }
      },
    },
    "filters.destination_dn_type": {
      handler(newVal) {
        this.sliceElementsDestination = 500;
        this.queueListSlicedDestination = [];
        this.extensionsListSlicedDestination = [];

        this.destination_key += 1; // Increment the key to force re-creation
        if (newVal === "") {
          this.filters.call_status = "all"; // Reset call status when destination type is cleared
        }
        this.$emit("clearDestinationDns");
      },
      deep: true,
    },
    "filters.origin_dn_type": {
      handler(newVal) {
        this.sliceElementsOrigin = 500;
        this.queueListSlicedOrigin = [];
        this.extensionsListSlicedOrigin = [];

        this.origin_key += 1;
        this.$emit("clearOriginDns");
      },
    },
  },
};
</script>

<style></style>
